import React from "react";

import { Card, CardTitle, Icon } from "./ui";

/*
  오른쪽 세로줄 — 아직 조치하지 않은 위반 목록.

  처음엔 여기에 준수율 게이지·시간대별 분포까지 올렸는데 화면이 난잡해졌다.
  추이·항목별·시간대별은 «안전 리포트»에 이미 있는 내용이라 대시보드에서 뺐다.
  대시보드가 답해야 하는 건 «지금 처리할 게 뭐냐» 하나다.
*/

function fmtTime(iso) {
  const m = String(iso || "").match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : "-";
}

function minutesSince(iso) {
  const t = Date.parse(String(iso || "").replace(" ", "T"));
  if (!Number.isFinite(t)) return null;
  return Math.max(0, Math.floor((Date.now() - t) / 60000));
}

export default function OpenQueue({
  openList = [],
  activeIndex = 0,
  onPick,
  onNavigate,
  oldestMin = null,
}) {
  const list = Array.isArray(openList) ? openList : [];

  return (
    <Card className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <CardTitle
        title="미조치 위반"
        right={
          <span
            className={`text-[12.5px] font-semibold tabular-nums ${
              list.length ? "text-rose-600 dark:text-rose-400" : "text-slate-400"
            }`}
          >
            {list.length}건
            {list.length > 0 && oldestMin != null && (
              <span className="ml-1.5 font-normal text-slate-400">
                최장 {oldestMin}분
              </span>
            )}
          </span>
        }
      />

      <div className="min-h-0 flex-1 overflow-y-auto">
        {list.length === 0 ? (
          <div className="flex h-full items-center justify-center px-4 text-center text-[12.5px] text-slate-400">
            모두 확인 처리됨
          </div>
        ) : (
          list.map((v, i) => {
            const min = minutesSince(v?.timestamp);
            const old = min != null && min >= 10;
            return (
              <button
                key={v.id}
                type="button"
                onClick={() => onPick?.(i)}
                className={`flex w-full items-center gap-3 border-b border-slate-100 px-4 py-3 text-left transition last:border-0 hover:bg-slate-50 dark:border-white/5 dark:hover:bg-white/5 ${
                  i === activeIndex ? "bg-blue-50/70 dark:bg-blue-500/10" : ""
                }`}
              >
                <span
                  className={`h-8 w-[3px] shrink-0 rounded-full ${
                    old ? "bg-rose-500" : "bg-amber-400"
                  }`}
                />
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-[13px] font-semibold text-slate-900 dark:text-white">
                    {v.itemLabel}
                  </span>
                  <span className="mt-[2px] block truncate text-[11.5px] text-slate-500 dark:text-slate-400">
                    {v.siteLabel}
                  </span>
                </span>
                <span className="shrink-0 text-right">
                  <span className="block text-[11.5px] font-medium text-slate-500 tabular-nums dark:text-slate-400">
                    {fmtTime(v.timestamp)}
                  </span>
                  {min != null && (
                    <span
                      className={`mt-[2px] block text-[11px] tabular-nums ${
                        old ? "font-semibold text-rose-500" : "text-slate-400"
                      }`}
                    >
                      {min}분 경과
                    </span>
                  )}
                </span>
              </button>
            );
          })
        )}
      </div>

      <button
        type="button"
        onClick={() => onNavigate?.("safety-report")}
        className="flex h-[42px] shrink-0 items-center justify-center gap-1.5 border-t border-slate-200 text-[12.5px] font-medium text-slate-500 transition hover:bg-slate-50 dark:border-white/10 dark:text-slate-400 dark:hover:bg-white/5"
      >
        <Icon.Chart size={14} />
        안전 리포트
        <Icon.Right size={13} />
      </button>
    </Card>
  );
}
